const moduleRoute = {
  path: '/attendance',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      // name: 'attendance',
      path: ':attendanceId/patient/:id',
      component: () => import('./views/Index.vue'),
      children: [
        // { path: '', component: () => import('./views/Dashboard.vue') },
      ]
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
